/** Arreglo 1 (oct-2026) — Mis clientes: API del barbero (solo sus clientes). */
import { api } from '@/lib/api';

const qs = (obj) => {
  const p = new URLSearchParams();
  Object.entries(obj).forEach(([k, v]) => { if (v !== undefined && v !== null && v !== '') p.set(k, String(v)); });
  const s = p.toString();
  return s ? `?${s}` : '';
};

export const clientsApi = {
  list({ q = '', letter, limit = 100, offset = 0 } = {}) { return api.get(`/clients${qs({ q, letter, limit, offset })}`); },
  search(q) { return api.get(`/clients/search?q=${encodeURIComponent(q)}`); },
  get(id) { return api.get(`/clients/${id}`); },
  bookings(id, scope = 'upcoming') { return api.get(`/clients/${id}/bookings?scope=${scope}`); },
  payments(id) { return api.get(`/clients/${id}/payments`); },
  photos(id) { return api.get(`/clients/${id}/photos`); },
  create(body) { return api.post('/clients', body); },
  update(id, body) { return api.put(`/clients/${id}`, body); },
  remove(id) { return api.delete(`/clients/${id}`); },
  setOnlineBooking(id, enabled) { return api.put(`/clients/${id}/online-booking`, { enabled }); },
  setCustomDuration(id, serviceId, minutes) { return api.put(`/clients/${id}/durations`, { service_id: serviceId, minutes }); },
  importPreview(file) { const fd = new FormData(); fd.append('file', file); return api.postForm('/clients/import/preview', fd); },
  importConfirm(rows) { return api.post('/clients/import', { rows }); },
  walkIn(body) { return api.post('/bookings/walk-in', body); },
  discardWalkIn(id) { return api.delete(`/bookings/walk-in/${id}`); },
};

export default clientsApi;
